module.exports = __webpack_public_path__ + "static/img/educacion.ba8c4b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/educacion.jpg
// module id = Nf0c
// module chunks = 47